(() => {
  if (customElements.get('masonry-layout')) {
    return;
  }

  class ComponentExample extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const msnry = new Masonry(this, {
        itemSelector: '.js-tile',
        columnWidth: '.js-tile',
        percentPosition: true,
        horizontalOrder: true,
        gutter: 32,
        transitionDuration: 0,
      });

      document.addEventListener('shopify:section:select', (event) => {
        setTimeout(() => {
          msnry.layout();
        }, '100');
      });
    }
  }

  customElements.define('masonry-layout', ComponentExample);
})();
